export default {
  title: 'Nieuw wachtwoord aanmaken',
  description: 'Maak een nieuw wachtwoord aan voor uw account.',
  form: {
    new_password: {
      label: 'Nieuw wachtwoord',
      placeholder: 'Wachtwoord invoeren',
      requirements: 'Uw wachtwoord moet 8 tekens, een hoofdletter en een cijfer bevatten',
    },
    confirm_password: {
      label: 'Nieuw wachtwoord bevestigen',
      placeholder: 'Wachtwoord bevestigen',
    },
    error_messages: {
      missing_info: 'Ontbrekende informatie',
    },
  },
  buttons: {
    update_password: 'Wachtwoord bijwerken',
  },
};
